
export const checkListKeywordStyle = theme => ({
    contentCheckbox: {
        display: 'flex',
    },
    labelCheckboxBlack: {
        color: "black",
        marginTop: 'auto',
        marginBottom: 'auto',
        "&:hover": {
            cursor:'pointer'
        }
    },
    labelCheckboxColorRed: {
        color: 'red',
        marginTop: 'auto',
        marginBottom: 'auto',
        "&:hover": {
            cursor: 'pointer'
        }
    },
})